import { Reducer } from '@reduxjs/toolkit';

const appParamsReducer: Reducer = (state, { payload }) => {
  if (!state) {
    return { params: null };
  }

  if (!payload) {
    return state;
  }

  return { ...state, params: payload };
};

export default appParamsReducer;
